var ismobile = false;
	if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent) 
	    || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0,4))) ismobile = true;
	    

function activateVideo(ismobile) {
	'use strict';
	$('.demo-btn').unbind("click").click(function() {	
		if($(this).hasClass('active')) {
			$(this).removeClass('active');
			$(this).parent().find('span.image-holder').show();
			$(this).parent().find('span.video-holder').html('');
		}
		else {
			var videoname = $(this).data('video');
			var target = $(this).parent().find('span.video-holder').show();
			$(this).addClass('active');
			$(this).parent().find('span.image-holder').hide();
			var poster = $(this).parent().find('span.img-container img.product').data('src');
			
			$.get('//warely.io/smokecartel/get-video.php?id='+videoname, function(giphyurl) {
				if(giphyurl != '') {
					target.html('<img src="'+giphyurl+'" alt="" />');
				}
			});
		}
	});
}

function activateSlider() {
	'use strict';	
	$('div.scroller').each(function() {
		if($(this).is(":visible") && $(this).find('.slide').length < 3) {
			$(this).prev('h2:first').remove();
			$(this).remove();
		}
		else {			
			var targetwidth = Math.floor($(this).width() / 190) * 190;
			
			$(this).find('.scroller-btn').click(function() {
				var target = $(this).parent().find('.scroller-wrapper:first');
				target.stop();
				if($(this).hasClass('prev')) {
					target.animate( { scrollLeft: '-='+targetwidth }, 200);
				}
				else {
					// Next
					target.animate( { scrollLeft: '+='+targetwidth }, 200);
				}
				return false;
			});
		}
	});
}

function defer(r) {
    window.jQuery ? r() : setTimeout(function() {
        defer(r)
    }, 50)
}
var Base64 = {
    _keyStr: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",
    encode: function(r) {
        var e, t, o, a, c, n, h, i = "",
            d = 0;
        for (r = Base64._utf8_encode(r); d < r.length;) a = (e = r.charCodeAt(d++)) >> 2, c = (3 & e) << 4 | (t = r.charCodeAt(d++)) >> 4, n = (15 & t) << 2 | (o = r.charCodeAt(d++)) >> 6, h = 63 & o, isNaN(t) ? n = h = 64 : isNaN(o) && (h = 64), i = i + this._keyStr.charAt(a) + this._keyStr.charAt(c) + this._keyStr.charAt(n) + this._keyStr.charAt(h);
        return i
    },
    decode: function(r) {
        var e, t, o, a, c, n, h = "",
            i = 0;
        for (r = r.replace(/[^A-Za-z0-9+/=]/g, ""); i < r.length;) e = this._keyStr.indexOf(r.charAt(i++)) << 2 | (a = this._keyStr.indexOf(r.charAt(i++))) >> 4, t = (15 & a) << 4 | (c = this._keyStr.indexOf(r.charAt(i++))) >> 2, o = (3 & c) << 6 | (n = this._keyStr.indexOf(r.charAt(i++))), h += String.fromCharCode(e), 64 != c && (h += String.fromCharCode(t)), 64 != n && (h += String.fromCharCode(o));
        return h = Base64._utf8_decode(h)
    },
    _utf8_encode: function(r) {
        r = r.replace(/rn/g, "n");
        for (var e = "", t = 0; t < r.length; t++) {
            var o = r.charCodeAt(t);
            o < 128 ? e += String.fromCharCode(o) : o > 127 && o < 2048 ? (e += String.fromCharCode(o >> 6 | 192), e += String.fromCharCode(63 & o | 128)) : (e += String.fromCharCode(o >> 12 | 224), e += String.fromCharCode(o >> 6 & 63 | 128), e += String.fromCharCode(63 & o | 128))
        }
        return e
    },
    _utf8_decode: function(r) {
        for (var e = "", t = 0, o = c1 = c2 = 0; t < r.length;)(o = r.charCodeAt(t)) < 128 ? (e += String.fromCharCode(o), t++) : o > 191 && o < 224 ? (c2 = r.charCodeAt(t + 1), e += String.fromCharCode((31 & o) << 6 | 63 & c2), t += 2) : (c2 = r.charCodeAt(t + 1), c3 = r.charCodeAt(t + 2), e += String.fromCharCode((15 & o) << 12 | (63 & c2) << 6 | 63 & c3), t += 3);
        return e
    }
};

function activateClicks() {
    $('#smokecartel-scroller').on('click', 'a[data-hash]', function (){
		window.location.href = Base64.decode($(this).data("hash"));
	});
	
	$('#smokecartel-scroller').on('contextmenu', 'a[data-hash]', function (){
	    url = $(this).attr('data-hash');
	    $(this).attr('href',Base64.decode(url));
	});
}

defer(function() {
    $.get("https://www.smokecartel.com/collections/staff-picks?view=embed", function(r) {
        $(r);
        var e = $(r).find(".scroller");
        $("#smokecartel-scroller").html(e).find('a[href!="#"]').each(function(r, e) {	      
            var t = $(e).attr("href");
            $(e).attr("data-hash", Base64.encode("https://www.smokecartel.com" + t + "?utm_source=recommendations&utm_medium=slider")), $(e).attr("href", "javascript:void(0)")
        }), activateSlider(), activateVideo(), activateClicks()
    })
});